var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"#fffff"}},[_c('app-navbar'),_c('app-router'),_c('app-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }